module.exports = __webpack_public_path__ + "media/images/product_large_images/paper(600)-852c1a5d73f985837bf5809353bf5840.png";